import React, { useCallback } from "react";
import { connect } from "react-redux";

import { faArrowsRotate, faCircleXmark, faLinkSimpleSlash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Col } from "antd/es/grid";
import Row from "antd/es/row";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import NylasType from "@app/enum/NylasType";
import { connectToMailNylas } from "@app/scene/settings/util/connectToNylas";
import { getEmailNylasInfo } from "@app/store/nylas";
import { deleteNylas } from "@app/store/nylas/actions";
import { RootState } from "@app/store/rootReducer";
import layout from "@app/styles/layout";
import NylasInfo from "@app/types/nylas/NylasInfo";

import messages from "./messages";
import styles from "./NylasErrored.module.scss";

interface Props {
  emailNylasInfo: NylasInfo | undefined;
  onDeleteNylas: typeof deleteNylas.request;
}

const NylasErrored: React.FC<Props> = ({ emailNylasInfo, onDeleteNylas }) => {
  const intl = useIntl();

  const handleDisconnect = useCallback(() => {
    if (emailNylasInfo) {
      onDeleteNylas({ nylasId: emailNylasInfo.id, type: NylasType.EMAIL });
    }
  }, [onDeleteNylas, emailNylasInfo]);

  return (
    <div className={styles.container}>
      <div>
        <FontAwesomeIcon className={styles.icon} icon={faCircleXmark} size="3x" />
      </div>
      <div className={styles.title}>{intl.formatMessage(messages.erroredTitle)}</div>
      <div className={styles.subTitle}>{intl.formatMessage(messages.erroredDescription)}</div>
      <div>
        <Row align="middle" gutter={layout.spacerM}>
          <Col>
            <Button
              leftIcon={<FontAwesomeIcon icon={faLinkSimpleSlash} />}
              onClick={handleDisconnect}
            >
              {intl.formatMessage(messages.erroredDisconnect)}
            </Button>
          </Col>
          <Col>
            <Button
              leftIcon={<FontAwesomeIcon icon={faArrowsRotate} />}
              onClick={connectToMailNylas}
              type="primary"
            >
              {intl.formatMessage(messages.erroredReAuthorize)}
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  emailNylasInfo: getEmailNylasInfo(state),
});

const mapDispatchToProps = {
  onDeleteNylas: deleteNylas.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(NylasErrored);
